export const initialFilterState = () => ({
  stationName: { value: [], isAll: true },
  status: { value: [], isAll: true },
  effectiveAt: null,
  searchKey: "",
  searchType: "stationCode",
  page: 1,
  perPage: 10,
});
